/// <amd-module name="VSS/Features/Frame/AssetResolver/AssetResolver" />
import { VssComponent } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";

export interface IAssetResolverProps {
    assets: string[];
    children: (resolvedAssets: string[]) => JSX.Element;
}

/**
 * Utility component to retrieve the locations of assets for use by children components.
 *
 * By extending VssComponent it has access to pageContext for the call to getAssetLocation without
 * code authors having to pass the context down to every single component they create.
 */
export class AssetResolver extends VssComponent<IAssetResolverProps> {
    public render(): JSX.Element {
        const resolvedAssets = this.props.assets.map(a => getAssetLocation(this.context.pageContext, a));
        return this.props.children(resolvedAssets);
    }
}
